import React from 'react'
import styled from 'styled-components'


import { TextLink } from '../Home/ButtonGroup'
import { StyledButton } from '../Home/StyledButton'
import OneLineInput from '../Form/OneLineInput'
import ModalHeader from './ModalHeader'

const Wrap = styled.div`
`

const ModalBody = styled.div`
text-align: center;
button
{
  margin-bottom: 8px;
}
button + button
{
  margin-bottom: 0;
}
a
{
  display: inline-block;
  margin-top: 8px;
}
form
{
  margin-bottom: 2rem;
}
`

const Fieldset = styled.div`
margin-bottom: 0.5rem;
display: inline-block;
width: 100%;
`

const InputContainer = styled.div`
position: relative;
margin-bottom: 1.2rem;
`

const Help = styled.p`
margin: 32px 0 8px 0;
font-size: 12px;
`

const SignIn = (props) => (
  <Wrap>
    <ModalBody>
      <ModalHeader headline="Sign In" subline="Enter your Username and Password"/>
      <form action="POST" className="modal-form signin" onSubmit={(e) => {
        e.preventDefault()
        // TODO: This will break if we have add inputs on the page
        const inputs = document.querySelectorAll('form input')

        const payload = {}
        for (let i = 0; i < inputs.length; i++) {
          const name = inputs[i].type
          const value = inputs[i].value
          payload[name] = value
        }

        payload.action = 'signin'

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/auth/email`, {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(res => res.json()).then(res => {
          if (!res.success) {
            alert(res.error)
          }

          else {
            window.location = '/bible'
          }
        })
      }}>

        <Fieldset>
          <InputContainer>
            <OneLineInput id="email" name="email" type="email" label="Email" required="required"/>
          </InputContainer>

          <InputContainer>
            <OneLineInput id="password" name="password" type="password" label="Password" required="required"/>
          </InputContainer>
        </Fieldset>

        <StyledButton variation='gold' isFullWidth="true">Sign Me In</StyledButton>
        <TextLink to='/forgot' variation="gray">Forgot Username or Password?</TextLink>
      </form>

      <Help>Don't have an account? <TextLink onClick={props.switchState} to='#' variation="darkgray">Sign Up</TextLink></Help>

    </ModalBody>
  </Wrap>
)

export default SignIn



// WEBPACK FOOTER //
// ./src/components/Modal/SignIn.js